import { useMemo } from "react";
import { Alert, Stack, Text } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";

import { useGrossCodes } from "../../hooks/useReferenceData";
import {
  GrossingCenter,
  type SpecimenGrossingData,
} from "../pathologist-review/GrossingCenter";

interface DirectCorrectionGrossingScreenProps {
  caseData: any;
  grossingDataMap: Map<string, SpecimenGrossingData>;
  changedSpecimenCount: number;
  onGrossingChange: (
    specimenId: string,
    data: Partial<SpecimenGrossingData>
  ) => void;
}

export function DirectCorrectionGrossingScreen({
  caseData,
  grossingDataMap,
  changedSpecimenCount,
  onGrossingChange,
}: DirectCorrectionGrossingScreenProps) {
  const grossCodesQuery = useGrossCodes();
  const grossCodes = useMemo(
    () => grossCodesQuery.data ?? [],
    [grossCodesQuery.data]
  );

  return (
    <Stack gap="md">
      <Alert
        icon={<IconInfoCircle size={18} />}
        color="blue"
        variant="light"
        title="Correct the signed grossing details"
        role="status"
      >
        <Text size="sm">
          Existing values are pre-filled. Source, subsite, findings, collection
          method, material, fragments, gross template, and gross description
          changes will be recorded in the correction history.
        </Text>
      </Alert>
      {changedSpecimenCount > 0 && (
        <Alert color="orange" variant="light" role="status">
          {changedSpecimenCount} specimen
          {changedSpecimenCount === 1 ? " has" : "s have"} unsaved correction
          changes.
        </Alert>
      )}
      <GrossingCenter
        caseData={caseData}
        grossingDataMap={grossingDataMap}
        onGrossingChange={onGrossingChange}
        grossCodes={grossCodes}
        canModifyStructure={false}
      />
    </Stack>
  );
}
